import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { Transportation, TransportationForm } from '../../../types/transportation';


export interface TransportationState {
  transportationTypeId: number | null
  fetchedTransportation: Transportation | null
  transportationForm: TransportationForm
  newPin: boolean
}

export const transportationFormInitialState = {
  phoneNumber: '',
  registrationNumber: '',
  driverName: '',
  email: '',
  authCode: '',
  carQuantity: '',
  carCompanyId: null,
  destinationId: null,
  voyage: '',
}

const initialState: TransportationState = {
  transportationTypeId: null,
  fetchedTransportation: null,
  newPin: true,
  transportationForm: {
    ...transportationFormInitialState,
  },
}

export const transportationSlice = createSlice({
  name: 'transportation',
  initialState,
  reducers: {
    resetTransportationSlice: () => initialState,
    setTransportationType: (state, action: PayloadAction<number>) => {
      state.transportationTypeId = action.payload
    },
    setFetchedTransportation: (state, action: PayloadAction<Transportation | null>) => {
      state.fetchedTransportation = action.payload
    },
    setTransportationForm: (state, action: PayloadAction<TransportationForm>) => {
      state.transportationForm = action.payload
    },
    setNewPin: (state, action: PayloadAction<boolean>) => {
      state.newPin = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  setTransportationType,
  resetTransportationSlice,
  setFetchedTransportation,
  setTransportationForm,
  setNewPin,
} = transportationSlice.actions

export default transportationSlice.reducer
